import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import * as APIActions from '../+state/actions/api.actions';
import * as SummarySelectors from '../+state/selectors/summary.selectors';
import { StateFacade as ContentFacade } from './content.facade';

@Injectable({
  providedIn: 'root'
})
export class TrackerFacade {
  tracker$ = this.store.pipe(
    select(SummarySelectors.getTracker),
    tap((data) => {
      if (data) {
        this.loaded = true;
      }
    })
  );

  loaded = false;

  constructor(private readonly store: Store, public content: ContentFacade) {}

  init(aem = true) {
    if (!this.loaded) {
      if (aem) {
        this.content.init();
      }
      this.store.dispatch(APIActions.loadTracker());
      this.store.dispatch(APIActions.loadFutureActivity());
    }
  }
}
